import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  console.error('Stripe publishable key is not set. Please check your environment variables.');
}

// Initialize the Stripe promise
export const stripePromise = loadStripe(stripePublishableKey);

export const STRIPE_CONFIG = {
  publishableKey: stripePublishableKey,
  appearance: {
    theme: 'stripe' as const,
  },
  loader: 'auto' as const,
};

export interface StripeCheckoutResponse {
  checkout_url: string;
  session_id: string;
}

export interface StripeSubscriptionStatus {
  has_subscription: boolean;
  subscriptions?: any[];
  stripe_customer_id?: string;
  message?: string;
} 